define('environments/development',{
  env: "development",
  defaultDomain: "https://signup.dev.mdirector.com/",
  backendUrl: "https://signup-backend.dev.mdirector.com",
  mdirectorUrl: "https://app.dev.mdirector.com",
  mdirectorPrivateUrl:
    "https://app.dev.mdirector.com/private?redirect=dashboard",
  landingsUrl: "https://landings.dev.mdirector.com",
  transUrl: "https://trans.dev.mdirector.com",
  automationUrl: "https://automation.dev.mdirector.com",
  authUrl: "https://auth.dev.mdirector.com",
  paymentsUrl: "https://payments.dev.mdirector.com/",
  captchaPublicKey: "6LeP380UAAAAANdkQPCqAs8UGGhwoti0x7Pjg8Mc",
  i18nCookieDomain: ".dev.mdirector.com",
  getProvincesUrl:
    "https://signup-backend.dev.mdirector.com/provinces/country/",
  getCountriesUrl: "https://signup-backend.dev.mdirector.com/countries",
  getUserDataUrl: "https://signup-backend.dev.mdirector.com/signup/",
  postUserServicesUrl: "https://signup-backend.dev.mdirector.com/user-services",
  submitUrl: "https://signup-backend.dev.mdirector.com/signup",
  secondStepRedir: "/activation",
  themeAssetsUrl: "https://static.dev.mdirector.com/assets/themes/",
  myAccountUrl: "https://signup.dev.mdirector.com/accounts",
  showBalanceArray: ["1884"],
  registerUrl: {
    es: "https://www.dev.mdirector.com/signup/",
    fr: "https://www.dev.mdirector.com/fr/signup/",
    it: "https://www.dev.mdirector.com/it/signup/",
    pt: "https://www.dev.mdirector.com/pt/signup/",
    en: "https://www.dev.mdirector.com/en/signup/",
  },
  ga: {
    ua: "UA-46499122-1",
    tagmanagerId: "GTM-WX6H3W",
    domain: "mdirector.com",
  },
  trackingFirstStepDefaultParams: {
    origin: "web",
    service: "mdirector",
    productId: "emailmarketing",
    productName: "Email Marketing",
    landingName: "No_LANDING_Direct_Registry",
  },
  securityOptionsAllowGroups: [],
  SECURE_PASSWORD_LENGTH: 8,
  SECURE_PASSWORD_MAX_LENGTH: 64,
  maintenanceUrl: "https://static.dev.mdirector.com/assets/js/maintenance.js",
  CPSAgreements: {
    cookieDismissName: "CPSAgreementsDismiss",
    cookieDismissValue: "ok",
    cookieDismissExpirationDays: 1,
    externalTermsURL: {
      es: "https://pmp.antevenio.com/mdirector/cps-mdirector-esp-es",
      en: "https://pmp.antevenio.com/mdirector/cps-mdirector-eng-es",
      it: "https://pmp.antevenio.com/mdirector-it/md-cps-it",
    },
    canBeDelayed: false,
  },
  integrations: {
    zapierEnabled: true,
    shopifyEnabled: true,
    APIsEnabled: true,
  },
});

